import api from '@/api'
import types from './attachmentsTypes'

export default {
  create (context, payload) {
    return api.attachment.create(payload)
  },

  async get (context, payload) {
    const attachments = await api.attachment.get(payload)

    context.commit(types.SET_ATTACHMENTS, attachments.data)
  },

  delete (context, payload) {
    return api.attachment.delete(payload)
  },

  set (context, attachmentsIds) {
    context.commit(types.SET_ATTACHMENTS, attachmentsIds)
  },
}
